<template>
    <b-card>
        <div v-if="loading" class="loading"/>

        <div class="mb-2 mt-2">
            <div class="d-block d-md-inline-block pt-1">
                <h4 class="mb-2 card-title">List of Facilities</h4>
            </div>

            <div class="float-md-right pt-1">
                <span class="text-muted text-small mr-1 mb-2">{{ meta.from }}-{{ meta.to }} of {{ meta.total }}</span>
                <b-dropdown id="ddown2" right :text="`${meta.per_page}`" variant="outline-dark"
                            class="d-inline-block" size="xs">
                    <b-dropdown-item v-for="(size,index) in meta.page_sizes" :key="index"
                                     @click="changePageSize(size)">{{ size }}
                    </b-dropdown-item>
                </b-dropdown>
            </div>
        </div>

        <b-table show-empty no-sort-reset class="vuetable" :current-page="meta.current_page" :per-page="meta.per_page"
                 :fields="table.fields" :items="fetchVendorFacilities">
            <template v-slot:cell(id)="data">
                <span v-text="data.item.data.attributes.code"/>
            </template>

            <template v-slot:cell(name)="data">
                <router-link class="text-data-link" :to="{path : '/hms/locations/' + data.item.links.self}"
                             v-text="data.item.data.attributes.name"/>
            </template>

            <template v-slot:cell(rate)="data">
                <span v-text="data.item.data.attributes.rate"/>
            </template>

            <template v-slot:cell(total_units)="data">
                <span v-text="data.item.data.attributes.total_units"/>
            </template>

            <template v-slot:cell(actual_units)="data">
                <span v-text="data.item.data.attributes.actual_units"/>
            </template>

            <template v-slot:cell(active_units)="data">
                <span v-text="data.item.data.attributes.active_units"/>
            </template>

            <template v-slot:cell(type)="data">
                <span v-text="data.item.data.attributes.type"/>
            </template>

            <template v-slot:cell(active)="data">
                <b-badge pill style="width: 58px;"
                         :variant="data.item.data.attributes.status === 'Active' ? 'info' : 'danger'">
                    {{ data.item.data.attributes.status }}
                </b-badge>
            </template>
        </b-table>

        <b-pagination size="sm" align="center" :total-rows="meta.total" :per-page="meta.per_page"
                      v-model="meta.current_page">
            <template v-slot:next-text>
                <i class="simple-icon-arrow-right"/>
            </template>

            <template v-slot:prev-text>
                <i class="simple-icon-arrow-left"/>
            </template>

            <template v-slot:first-text>
                <i class="simple-icon-control-start"/>
            </template>

            <template v-slot:last-text>
                <i class="simple-icon-control-end"/>
            </template>
        </b-pagination>
    </b-card>
</template>

<script>
    import { mapGetters } from 'vuex';

    export default {
        name: "VendorFacilitiesList",

        data() {
            return {
                loading: true,
                table: {
                    fields: [
                        {key: 'id', label: 'Code'},
                        {key: 'name', label: 'Name'},
                        {key: 'rate', label: 'Rate', tdClass: 'text-muted'},
                        {key: 'total_units', label: 'Contract Units', tdClass: 'text-muted'},
                        {key: 'actual_units', label: 'Actual Units', tdClass: 'text-muted'},
                        {key: 'active_units', label: 'Active Units', tdClass: 'text-muted'},
                        {key: 'type', label: 'Type', tdClass: 'text-muted'},
                        {key: 'active', label: 'Status', thClass: 'text-center', tdClass: 'text-center'},
                    ]
                }
            }
        },

        computed: {
            ...mapGetters({
                meta: 'getVendorFacilitiesMeta',
            }),
        },

        methods: {
            changePageSize(per_page) {
                this.meta.per_page = per_page;
            },

            fetchVendorFacilities() {
                return this.$store.dispatch('fetchVendorFacilities', this.$route.params.vendor_id)
                    .then(facilities => {
                        return facilities.data;
                    })
                    .finally(() => {
                        this.loading = false;
                    });
            },
        }
    }
</script>
